import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole }) => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  
  if (!auth) {
    // Not logged in
    return <Navigate to="/" replace />;
  }
  
  if (requiredRole === "admin" && !auth.isAdmin) {
    // Not admin but trying to access admin route
    return <Navigate to="/simApp" replace />;
  }
  
  if (requiredRole === "institute" && auth.isAdmin) {
    // Admin trying to access institute route
    return <Navigate to="/ViewSentApplication" replace />;
  }
  
  return children;
};

export default ProtectedRoute;